import { Component, EventEmitter, OnInit } from '@angular/core';
import { Compare } from 'src/app/shared/utilities';

export class headerDesc<T> {
  title:string;
  width:number;
  order:number;
  pipe:(d:T)=>string;
  click?:(d:T)=>void = null
}
@Component({
  selector: 'app-grid-dialog',
  templateUrl: './grid-dialog.component.html',
  styleUrls: ['./grid-dialog.component.css']
})
export class GridDialogComponent<T> implements OnInit {

  title:string='';
  pageSize:number = 10;
  hideClose:boolean = false;
  gridData:T[] = [];
  headers:Partial<{[key in keyof T]:headerDesc<T>}> = null;
  headerAry:({field:string}&headerDesc<T>)[] = [];
  gridView:{[key in keyof T]:string}[] = [];
  onClose:EventEmitter<boolean>= new EventEmitter();
  constructor() { }

  ngOnInit(): void {
    this.headerAry = [];
    if(this.headers){
      for(let h in this.headers){
        this.headerAry.push(Object.assign({
          field:h
        } ,this.headers[h]));
      }
      this.headerAry = this.headerAry.sort((a,b)=>Compare(a.order,b.order))
    }
    this.gridView = [];
    this.gridView = this.gridData.map(x=>{
      var o:any = {};
      for(let f in x){
        if(this.headers[f]){
          var pipeFn = this.headers[f].pipe;
          var pipedValue = pipeFn(x);
          o[f]=pipedValue;
        }
      }
      return o
    });
  }
  updateData(data:T[]){
    this.gridData = data
    this.gridView = this.gridData.map(x=>{
      var o:any = {};
      for(let f in x){
        if(this.headers[f]){
          var pipeFn = this.headers[f].pipe;
          var pipedValue = pipeFn(x);
          o[f]=pipedValue;
        }
      }
      return o
    });
  }
  close(){
    this.onClose.emit();
  }
  
}
